import { type PlacementWithLogical, Tooltip } from '@chakra-ui/react'

interface Props {
  children: React.ReactNode
  content: string | React.ReactNode
  placement?: PlacementWithLogical
  disabled?: boolean
  hasArrow?: boolean
}

export default function Tippy({ children, content, placement = 'top', disabled, hasArrow }: Props) {
  return (
    <Tooltip label={content} placement={placement} isDisabled={disabled} hasArrow={hasArrow}>
      {children}
    </Tooltip>
  )
}
